import React, {KeyboardEvent, useState} from 'react';
import SearchIcon from "../../../../ui/svg/common/search";
import { useWindowSize} from "../../../../domain/common";



const MainSupportSearch = () => {

    const [inputValue, setInputValue] = useState("");
    const _imgCdnDomain = (document.getElementById('img-cdn-domain')?.textContent || '')?.trim().toLowerCase();

    const TABLET_BREAKPOINT_START = 600;
    const TABLET_BREAKPOINT_END = 1279;
    /**
     * handle key up event - query search on Enter
     */
    const handleKeyUp = async (evt: KeyboardEvent) => {

        if(evt.key === 'Enter') {
            await Search();
        }
    };

    /**
     * handle search action on page number 1
     */
    const Search = async () => {
        window.location.href =  "/support/search?q=" + inputValue
    };

    // Window Size Hook.
    const size = useWindowSize();

    let _backGroundImage ="";

    if(size.width !== undefined && size.width < TABLET_BREAKPOINT_START){
        //mobile image
        _backGroundImage = "url(\""+_imgCdnDomain+"/images/support/main/top.png?w="+size.width+"&h="+size.width+"&fit=crop&crop=left&fp-x=.24\")";
    }else if(size.width !== undefined && size.width < TABLET_BREAKPOINT_END){
        //tablet  image
        _backGroundImage = "url(\""+_imgCdnDomain+"/images/support/main/top.png?w="+size.width+"&h="+(size.width !== undefined ? size.width * 0.35 : 0)+"&fit=crop&crop=left&fp-x=.1\")";
    }else if(size.width !== undefined && size.width >= TABLET_BREAKPOINT_END){
        //desktop image
        _backGroundImage = "url(\""+_imgCdnDomain+"/images/support/main/top.png?fit=scale&w="+size.width+"\")";
    }

    const bgImage = _backGroundImage;

    return (
        <div className="w-full" style={{backgroundRepeat:"no-repeat",backgroundImage : bgImage}}>
            <div className="lg:waves-box-lg lg:mx-auto mb-8 pb-28 md:pb-12 xl:pb-32 overflow-hidden">
                <div className="flex items-center justify-center p-4 pb-8 md:pb-2" >
                    <h1 className="w-2/3 md:w-auto  text-3xl lg:text-5xl font-bold text-center mt-24 md:mt-12 lg:mt-16 xl:mt-24 text-white">How Can We Help You?</h1>

                </div>
                <div className="w-full flex items-center justify-center px-5 md:px-32 lg:px-0 lg:mt-4">
                    <div className="waves-box-sm border border-gray-200-ho bg-gray-100 outline-none rounded-full flex items-center justify-center">
                        <input
                            type="text"
                            className="w-full bg-white rounded-full flex-1 p-3 pl-4 md:p-2 md:pl-6 outline-none xl:pl-8"
                            value={ inputValue}
                            placeholder="Search Waves Support"
                            onKeyUp={ async evt => {
                                await handleKeyUp(evt);
                            }}
                            aria-label="Search Support"
                            onChange={evt => {
                                setInputValue(evt.target.value);
                            }}
                        />
                        <div className="p-3 md:p-5 pr-4 xl:pr-8 cursor-pointer" onClick={Search}>
                            <SearchIcon width="15px" color="#252525" title="Filter" />
                        </div>
                    </div>
                </div>
            </div>

        </div>



    )
};

export default MainSupportSearch;